import React from "react";

const CHANNELS = [
    {
        value: "email",
        label: "Email",
        description: "Send a detailed reminder by email.",
        icon: "✉",
    },
    {
        value: "whatsapp",
        label: "WhatsApp",
        description: "Send a reminder through WhatsApp.",
        icon: "◉",
    },
    {
        value: "sms",
        label: "SMS",
        description: "Send a short text message.",
        icon: "▣",
    },
];

const ReminderChannels = ({ channels, onChange }) => {
    const toggleChannel = (channel) => {
        const updated = channels.includes(channel)
            ? channels.filter((item) => item !== channel)
            : [...channels, channel];

        onChange(updated);
    };

    return (
        <div className="reminder-channels">
            <div className="subsection-heading">
                <div>
                    <strong>
                        Delivery channels
                    </strong>

                    <span>
                        Choose where this reminder should be sent.
                    </span>
                </div>
            </div>

            <div className="channel-options">
                {CHANNELS.map((channel) => {
                    const selected = channels.includes(channel.value);

                    return (
                        <button
                            key={ channel.value }
                            type="button"
                            className={`channel-option ${ selected ? "selected" : "" }`}
                            onClick={() => toggleChannel(channel.value) }
                        >
                            <span className="channel-icon">
                                { channel.icon }
                            </span>

                            <span className="channel-content">
                                <strong>
                                    { channel.label }
                                </strong>

                                <small>
                                    { channel.description }
                                </small>
                            </span>

                            <span className="channel-check">
                                {selected ? "✓" : ""}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default ReminderChannels;
